import React, { useState, useEffect } from "react";
import {
	FaCheckCircle,
	FaTimesCircle,
	FaEyeSlash,
	FaEye,
	FaRegCircle,
	FaRegCheckCircle,
} from "react-icons/fa";

const icons = {
	tick: FaCheckCircle,
	cross: FaTimesCircle,
	eyeOpen: FaEye,
	eyeClosed: FaEyeSlash,
	checkCircleOn: FaRegCheckCircle,
	checkCircleOff: FaRegCircle,
};

export const ToggleIcon = ({
	onClick,
	selection,
	classes,
	colours,
	colourClasses,
}) => {
	const [sel, setSel] = useState(selection);
	const c = classes || "";

	const clickHandler = () => {
		if (onClick) {
			onClick(selection);
		}
	};

	useEffect(() => {
		setSel(selection);
	}, [selection]);

	if (sel == null) {
		return <></>;
	}

	const Icon = icons[sel];
	const colour = colours ? colours[sel] || "white" : null;
	const colourClass = colourClasses
		? colourClasses[sel] || "text-gray-600"
		: null;

	return (
		<Icon
			onClick={clickHandler}
			className={`${c} ${
				onClick ? "cursor-pointer" : "cursor-default"
			} ${colourClass}`}
			style={{ color: colour }}
		/>
	);
};
